import { render } from "./j-bread-item.vue?vue&type=template&id=1029b68e"
import script from "./j-bread-item.vue?vue&type=script&lang=js"
export * from "./j-bread-item.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__